module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/10-38bec59c2c9b49e5f1c4a0b59062b884.jpg";